module.exports = __webpack_public_path__ + "static/img/logo-vrs-black.82f6986.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-vrs-black.png
// module id = wBzX
// module chunks = 1